import { Booking, TableCell } from './booking-types';
import { applyBookings } from './calendar-apply-bookings';
import { createCalenderYear } from './create-calendar-month';

export const createCalender = (year: number, bookings: Booking[]): TableCell[] => {
  const yearCells = createCalenderYear(year);

  return applyBookings(year, yearCells, bookings);
};
